// extracted by mini-css-extract-plugin
export default {"container":"HealthyEatingPath_container__BiExU","navigation":"HealthyEatingPath_navigation__bA4P6","navigationItem":"HealthyEatingPath_navigationItem__ppHCb"};